import React, { Component } from "react";
import { Badge, Table, Glyphicon, FormGroup, ControlLabel, HelpBlock, OverlayTrigger } from 'react-bootstrap';
import { format, toInt, getTimeInIST, format_without_time, popover, handleApproveStoreDeliveryChange, format_fancy, fetchStoreContracts, convertDistance, format_fancy_notime, formatNumber } from '../Utils'
import moment from 'moment';
import '../css/storedelivery.css';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DeliveryService } from "../Services/DeliveryService";
import { Constants } from "../Constants";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import { UserService } from "../Services/UserService";
import { ProductService } from "../Services/ProductService";
import CollectPayment from "../CollectPayment";
import { NotificationService } from '../Services/NotificationService';

import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles, Chip, Tooltip, ListItemText, LinearProgress } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { RowCountOptions } from "../Config";
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { ROLES } from "../Roles";
import { OrganisationService } from "../Services/OrganisationService";

export const TxnType = {
    CASH: "CASH",
    CHEQUE: "CHEQUE"
}

export const PaymentStatus = {
    COLLECTED: "COLLECTED",
    PENDING: "PENDING",
    CANCELLED: "CANCELLED"
}

const styles = theme => ({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "100%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom: '20px',
    },
});

class StoreDeliverySchedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showNewDelivery: false,
            data: [],
            selectedDate: moment(),
            storeDeliveryMap: new Map(),
            storeMap: new Map(),
            current_rows: [],
            modal: { store: {}, deliveries: [] },
            highlightDates: [],
            new_delivery: { schedule_date: moment(), products: new Map(), returns: new Map(), delivery_date: undefined },
            storeList: [],
            selectedStore: {},
            product_rows: [],
            products: [],
            deliveryProductMap: new Map(),
            editMode: false,
            approvalRequired: false,
            payment: {},
            collectPaymentModal: null,
            show_approval_option: false,

            numItemsPerPage: 10,
            currentPageNumber: 0,
            totalItems: 0,
            totalPages: 0,
            columns: [
                { id: 'store_name', numeric: false, disablePadding: false, label: 'Store', sortable: false },
                { id: 'name', numeric: false, disablePadding: false, label: 'Manager Name', sortable: false },
                { id: 'mobile_no', numeric: false, disablePadding: false, label: 'Contact No', sortable: false },
                { id: 'flat', numeric: false, disablePadding: false, label: 'Address', sortable: false },
                { id: 'invoice_no', numeric: false, disablePadding: false, label: 'Invoice No', sortable: false },
                { id: 'grn', numeric: false, disablePadding: false, label: 'GRN', sortable: false },
                { id: 'po_no', numeric: false, disablePadding: false, label: 'PO No', sortable: false },
                { id: 'away', numeric: true, disablePadding: false, label: 'Distance from store', sortable: false },
                { id: 'issued_qty', numeric: false, disablePadding: false, label: 'Scheduled Qty', sortable: false },
                { id: 'total_amount', numeric: false, disablePadding: false, label: 'Total Amount', sortable: false },
                { id: 'delivered_count', numeric: false, disablePadding: false, label: 'Delivered Count', sortable: false },
                { id: 'returned_count', numeric: false, disablePadding: false, label: 'Returned Count', sortable: false },
                { id: 'delivery_date', numeric: false, disablePadding: false, label: 'Delivery Date', sortable: false },
                { id: 'actions', numeric: false, disablePadding: false, label: '', sortable: false },
            ],
            store_contract: new Map(),
            loading: false,
            scheduling_due_check: false
        }

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.showDetails = this.showDetails.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.resetNewDelivery = this.resetNewDelivery.bind(this);

        this.handleCloseNew = this.handleCloseNew.bind(this);
        this.handleShowNew = this.handleShowNew.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDeliveryDateChange = this.handleDeliveryDateChange.bind(this);
        this.scheduleNewDelivery = this.scheduleNewDelivery.bind(this);
        this.updateDeliveryDetails = this.updateDeliveryDetails.bind(this);

        this.edit = this.edit.bind(this);
        this.delete = this.delete.bind(this);
        this.resendInvoice = this.resendInvoice.bind(this);
        this.collectPayment = this.collectPayment.bind(this);
        this.postUpdate = this.postUpdate.bind(this);
    }

    // componentWillMount(){
    //     this.props.isLoading(true);
    //     // this.fetchTotalCount();
    // }

    fetchTotalCount = (postExecute = undefined) => {
        this.props.showProgressDialog();
        DeliveryService.getTotalDeliveryScheduleCount(this.state.selectedDate)
            .then((data) => {
                this.setState({
                    totalItems: toInt(data.count),
                    totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
                });
                this.props.isLoading(false);
                if (postExecute) {
                    postExecute();
                } else {
                    this.props.closeProgressDialog();
                }
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
                this.props.closeProgressDialog();
            });
    }

    componentDidMount() {
        this.props.setTitle('Store Delivery Schedules');
        OrganisationService.getOrganisationDetails()
            .then((data) => {
                this.setState({ scheduling_due_check: (data.organisation && data.organisation.scheduling_due_check === '1' ? true : false) });
            })
            .catch(error => {
                console.log(error);
            });
        this.fetchStoreList();
        this.fetchTotalCount(() => {
            this.fetchData(0, this.state.numItemsPerPage, this.state.selectedDate);
        });
        this.fetchCalendarMarkers(this.state.selectedDate);
        this.fetchProductRows(null, null);
    }

    fetchStoreList() {
        UserService.getStoreList(0, 10000, '', '', '', '0,1,2')
            .then((data) => {
                console.log(data);
                this.setState({ storeList: data.users });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage: event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, this.state.selectedDate, false, true));
    }

    handleChangePage = (event, page) => {
        if (this.state.currentPageNumber > page) {
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    handleSelect = (eventKey, e) => {
        if (eventKey === 'prev') {
            if ((this.state.currentPageNumber) > 0) {
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if (eventKey === 'next') {
            if ((this.state.currentPageNumber) < this.state.totalPages) {
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage) {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage, this.state.selectedDate, false, true);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    fetchData(start, numberItems, date, update, showLoader = true) {
        let storeDeliveryMap = new Map(), storeMap = new Map(), current_rows = [];
        if (showLoader)
            this.props.isLoading(true);
        DeliveryService.getDeliverySchedule(date, start, numberItems)
            .then((data) => {
                console.log(data);
                if (data.delivery_schedule && data.delivery_schedule.length > 0) {

                    data.delivery_schedule.forEach(element => {
                        let a = [], b = {};
                        if (storeMap.has(element.transaction_id)) {
                            b = storeMap.get(element.transaction_id);
                            b.product_qty += toInt(element.product_qty);
                            b.revised_delivered_count += toInt(element.revised_delivered_count);
                            b.delivered_count += toInt(element.delivered_count);
                            b.total_amount += toInt(element.delivered_count) > 0 ? parseFloat(element.total_amount) : 0;
                            b.returned_count += toInt(element.returned_count);
                            b.revised_returned_count += toInt(element.revised_returned_count);
                            b.replaced_count += toInt(element.replaced_count);
                            if (!b.delivery_date) {
                                b.delivery_date = element.delivery_date;
                            }
                            if (!b.invoice_no) {
                                b.invoice_no = element.invoice_no;
                            }
                            if (!b.grn) {
                                b.grn = element.grn;
                            }
                            if (!b.credit_note_url) {
                                b.credit_note_url = element.credit_note_url;
                            }
                            if (!b.invoice_url) {
                                b.invoice_url = element.invoice_url;
                            }
                            if (!b.delivery_agent_id) {
                                b.delivery_agent_id = element.delivery_agent_id;
                            }
                        } else {
                            b.id = element.id;
                            b.transaction_id = element.transaction_id;
                            b.invoice_no = element.invoice_no;
                            b.grn = element.grn;
                            b.away = parseFloat(element.away);
                            b.store_name = element.store_name;
                            b.name = element.name;
                            b.mobile_no = element.mobile_no;
                            b.flat = element.flat;
                            b.po_no = element.po_no;
                            b.product_qty = toInt(element.product_qty);
                            b.revised_delivered_count = toInt(element.revised_delivered_count);
                            b.delivered_count = toInt(element.delivered_count);
                            b.total_amount = toInt(element.delivered_count) > 0 ? parseFloat(element.total_amount) : 0;
                            b.returned_count = toInt(element.returned_count);
                            b.revised_returned_count = toInt(element.revised_returned_count);
                            b.replaced_count = toInt(element.replaced_count);
                            b.delivery_date = element.delivery_date;
                            b.schedule_date = element.schedule_date;
                            b.route_id = element.route_id;
                            b.invoice_url = element.invoice_url;
                            b.credit_note_url = element.credit_note_url;
                            b.transactions = element.transactions;
                            b.approval_pending = element.approval_pending;
                            b.approver_user_id = element.approver_user_id;
                            b.approver_name = element.approver_name;
                            // b.signature = element.signature;
                            b.reason = element.reason;
                            b.delivery_agent_id = element.delivery_agent_id;
                            b.geo_location = element.geo_location;
                            b.generate_invoice = element.generate_invoice && element.generate_invoice === '1' ? true : false;
                        }
                        storeMap.set(element.transaction_id, b);

                        if (storeDeliveryMap.has(element.transaction_id)) {
                            a = storeDeliveryMap.get(element.transaction_id);
                        }
                        a.push(element);
                        storeDeliveryMap.set(element.transaction_id, a);
                    });
                    storeMap.forEach((value, key, map) => {
                        current_rows.push(
                            <DeliveryDetails key={key} user={value} showDetails={this.showDetails} edit={this.edit} delete={this.delete} resendCreditNote={this.resendCreditNote} resendInvoice={this.resendInvoice} collectPayment={this.collectPayment} session_user={this.props.user} />
                        );
                    });
                }
                this.setState({
                    current_rows: current_rows, data: data.delivery_schedule, storeMap: storeMap, storeDeliveryMap: storeDeliveryMap, message: data.delivery_schedule.length > 0 ? "" : "No Data available"
                }, () => {
                    if (update) {
                        this.fetchProductRows(this.state.new_delivery.store_id, this.state.new_delivery.invoice_no, this.state.new_delivery.transaction_id);
                    }
                });
                if (showLoader)
                    this.props.isLoading(false);
                this.props.closeProgressDialog();
            })
            .catch(error => {
                console.log(error);
                this.props.closeProgressDialog();
                if (showLoader)
                    this.props.isLoading(false);
            });
    }

    fetchProductRows(store_id, invoice_no = undefined, transaction_id = undefined) {
        this.setState({ product_rows: [] });
        let s = null, nd = null, prodMap = new Map(), returnMap = new Map();
        nd = this.state.new_delivery;
        if (store_id && transaction_id) {
            s = this.state.storeDeliveryMap.get(transaction_id);
            if (invoice_no)
                s = s.filter(ss => ss.invoice_no === invoice_no);

            if (s && s.length > 0 && this.state.new_delivery_orginal) {
                this.setState(prevState => ({ new_delivery_orginal: { ...prevState.new_delivery_orginal, schedules: s } }));
            }
        }
        ProductService.getProductList()
            .then((data) => {
                console.log(data);
                let products = [], pr = [];
                data.products.filter(p => p.status !== -1).forEach((p) => {
                    p.product_qty = 0;
                    products.push(p);
                });
                this.setState({ products: products });
                let store_contract = this.state.store_contract;
                this.state.products.forEach((product, index) => {
                    let value = product.product_qty;
                    let returned_count = 0;
                    let currSch = null;
                    if (s) {
                        let schedule_date = moment.isMoment(this.state.new_delivery.schedule_date) ? this.state.new_delivery.schedule_date.startOf('day').format(format) : this.state.new_delivery.schedule_date;
                        currSch = s.filter((schedule) => schedule.product_id === product.id && moment(schedule.schedule_date).format(format) === schedule_date);
                        if (currSch.length === 1) {
                            value = this.state.approvalRequired ? (toInt(currSch[0].revised_delivered_count) === 0 ? toInt(currSch[0].delivered_count) : toInt(currSch[0].revised_delivered_count)) : ((!this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date ? true : false) ? currSch[0].delivered_count : toInt(currSch[0].product_qty));
                            returned_count = toInt(currSch[0].revised_returned_count) === 0 ? toInt(currSch[0].returned_count) : toInt(currSch[0].revised_returned_count);
                            returnMap.set(currSch[0].product_id, returned_count);
                            if (!(!this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date)) {
                                prodMap.set(currSch[0].product_id, value);
                            }
                        }
                    }
                    if ((currSch && currSch.length === 1) || store_contract.has(product.id)) {
                        pr.push(
                            <tr key={index}>
                                <td style={{ verticalAlign: "middle" }}>{product.name}</td>
                                <td style={{ verticalAlign: "middle" }}>
                                    <TextField
                                        label={this.state.approvalRequired ? "Delivered Count" : "Qty"}
                                        placeholder={this.state.approvalRequired ? "Delivered Count" : "Qty"}
                                        name={product.id}
                                        defaultValue={value}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        disabled={!this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date ? true : false}
                                        helperText={!this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date ? `Already Delivered @ ${getTimeInIST(currSch[0].delivery_date).format(format_fancy)}` : ''}
                                        error={(!this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date) ? true : false}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">Nos</InputAdornment>,
                                            inputProps: { min: 0, step: 1 }
                                        }} />
                                </td>
                                {
                                    this.state.approvalRequired &&
                                    <td style={{ verticalAlign: "middle" }}>
                                        <TextField
                                            id="returned"
                                            label="Returned Count"
                                            placeholder="Returned Count"
                                            name={product.id}
                                            defaultValue={returned_count}
                                            className={this.props.classes.textField}
                                            margin="dense"
                                            variant="outlined"
                                            onChange={this.handleChangeReturn}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">Nos</InputAdornment>,
                                                inputProps: { min: 0, step: 1 }
                                            }} />
                                    </td>
                                }
                            </tr>
                        );
                    }
                });
                /* disabled={currSch && currSch.length === 1 && currSch[0].delivery_date} */
                if (store_id) {
                    nd.products = prodMap;
                    nd.returns = returnMap;
                    this.setState({ new_delivery: nd });
                }
                this.setState({ product_rows: pr });
                // this.setState({product_rows: pr});
            })
            .catch(error => console.log(error));
    }

    handleMonthChange(date) {
        this.fetchCalendarMarkers(date);
    }

    fetchCalendarMarkers(date) {
        let fromDate = moment(date).startOf('month').format(format);

        let toDate = moment(date).add(1, 'M').endOf('month').format(format);

        DeliveryService.getDeliveryScheduleForCalendar(Constants.STORE, fromDate, toDate)
            .then((data) => {
                console.log(data);
                let markers = []
                data.markers.forEach(element => {
                    markers.push(moment(element.schedule_date));
                });
                this.setState({
                    highlightDates: [
                        { "react-datepicker__day--highlighted": markers }
                    ]
                });
            })
            .catch((error) => console.log(error));
    }

    handleDateChange(date) {
        let nd = this.state.new_delivery;
        nd.schedule_date = date;
        this.setState({
            selectedDate: date,
            new_delivery: nd
        }, () => {
            this.fetchTotalCount(() => {
                this.fetchData(0, this.state.numItemsPerPage, date);
            });
        });
    }

    showDetails(e, user) {
        let deliveries = [];
        this.state.storeDeliveryMap.get(user.transaction_id).forEach((element, index) => {
            // if(user.invoice_no === element.invoice_no){
            deliveries.push(<ProductDeliveryDetails key={element.id + index} delivery={element} />);
            // }
        });
        this.setState({ modal: { store: user, deliveries: deliveries }, show_approval_option: user.approval_pending === '1' ? true : false });
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false, show_approval_option: false, loading: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleCloseNew() {
        this.setState({ showNewDelivery: false, editMode: false, approvalRequired: false, store_contract: new Map() });
        this.resetNewDelivery();
    }

    handleShowNew() {
        this.setState({ showNewDelivery: true, payment: {} }, () => this.fetchProductRows(this.state.new_delivery.store_id, this.state.new_delivery.invoice_no, this.state.new_delivery.transaction_id));
    }

    handleChangePO = (e) => {
        e.preventDefault();
        let change = this.state.new_delivery;
        change[e.target.name] = e.target.value;
        this.setState({ new_delivery: change });
    }

    handleDeliveryDateChange(date) {
        let nd = this.state.new_delivery;
        nd.schedule_date = date;
        this.setState({
            selectedDate: date,
            new_delivery: nd
        }, () => {
            this.fetchTotalCount(() => {
                this.fetchData(0, this.state.numItemsPerPage, date, true);
            });
        });
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.new_delivery;
        let products = change.products;
        products.set(e.target.name, e.target.value);
        change.products = products;
        this.setState({ new_delivery: change });
    }

    handleChangeReturn = (e) => {
        e.preventDefault();
        let change = this.state.new_delivery;
        let returns = change.returns;
        returns.set(e.target.name, e.target.value);
        change.returns = returns;
        this.setState({ new_delivery: change });
    }

    confirmScheduleNewDelivery = () => {
        let rows = [];
        let nd = this.state.new_delivery;
        let { new_delivery_orginal, approvalRequired } = this.state;
        let proceed = false;
        let message = 'No changes made';
        if (approvalRequired && new_delivery_orginal) {
            nd.products.forEach((value, key) => {
                let returnValue = toInt(nd.returns.has(key) ? nd.returns.get(key) : 0);
                // if(toInt(value) > 0 || returnValue > 0){
                let s = new_delivery_orginal.schedules.filter(s => s.product_id === key && s.schedule_date === nd.schedule_date);
                if (s.length === 1) {
                    let valueTocompare = s[0].approval_pending === '1' ? toInt(s[0].revised_delivered_count) : toInt(s[0].delivered_count);
                    let valueTocompareReturns = s[0].approval_pending === '1' ? toInt(s[0].revised_returned_count) : toInt(s[0].returned_count);
                    if ((valueTocompare !== toInt(value) || valueTocompareReturns !== returnValue)) {
                        // if((valueTocompare !== toInt(value) || valueTocompareReturns !== toInt(nd.returns.get(key)))){
                        proceed = true;
                    }
                } else if (s.length === 0) {
                    proceed = true;
                }
                // }
            });
            if (!proceed) {
                nd.returns.forEach((value, key) => {
                    let s = new_delivery_orginal.schedules.filter(s => s.product_id === key && s.schedule_date === nd.schedule_date);
                    if (s.length === 1) {
                        let valueTocompareReturns = s[0].approval_pending === '1' ? toInt(s[0].revised_returned_count) : toInt(s[0].returned_count);
                        if (valueTocompareReturns !== toInt(value)) {
                            proceed = true;
                        }
                    } else if (s.length === 0) {
                        proceed = true;
                    }
                });
            }
        } else {
            if (nd.store_id) {
                nd.products.forEach((value, key) => {
                    if (toInt(value) > 0) {
                        proceed = true;
                    }
                });
                message = 'Select Products and proceed';
            } else {
                message = 'Select Store and proceed';
            }
        }

        if (proceed) {
            let message = (
                <Typography component="span">
                    Confirm {this.state.approvalRequired ? 'Schedule Changes' : 'Schedule'} for store
                    <span style={{ color: 'black', fontWeight: 'bolder' }}> {this.state.new_delivery.store_name}</span>
                    , Date
                    <span style={{ color: 'black', fontWeight: 'bolder' }}> {moment(this.state.new_delivery.schedule_date).format(format_fancy_notime)}</span>
                    ?
                </Typography>
            );
            this.props.showConfirmDialog(message, undefined, () => {
                this.props.closeConfirmDialog();
                this.setState({ loading: true });
                nd.products.forEach((value, key, map) => {
                    let p = this.state.products.filter((p) => p.id === key)[0];
                    let total_amount = toInt(value) * parseFloat(p.unit_price, 10);
                    // let po_no = this.state.storeList.filter((store) => store.id === nd.store_id)[0].po_no;
                    rows.push({
                        id: nd.id,
                        transaction_id: nd.transaction_id,
                        user_id: nd.store_id,
                        product_id: key,
                        schedule_date: moment(nd.schedule_date).format(format_without_time),
                        product_qty: toInt(value),
                        returned_count: toInt(nd.returns.has(key) ? nd.returns.get(key) : 0),
                        total_amount: total_amount,
                        po_no: nd.po_no,
                        invoice_no: nd.invoice_no,
                        delivery_agent_id: nd.delivery_agent_id,
                        delivery_date: nd.delivery_date,
                        geo_location: nd.geo_location,
                        route_id: nd.route_id
                        // signature : nd.signature
                    });
                });
                if (nd.delivery_date) {
                    nd.returns.forEach((value, key, map) => {
                        if (!nd.products.has(key)) {
                            let total_amount = 0;
                            // let po_no = this.state.storeList.filter((store) => store.id === nd.store_id)[0].po_no;
                            rows.push({
                                id: nd.id,
                                transaction_id: nd.transaction_id,
                                user_id: nd.store_id,
                                product_id: key,
                                schedule_date: moment(nd.schedule_date).format(format_without_time),
                                product_qty: 0,
                                returned_count: toInt(value),
                                total_amount: total_amount,
                                po_no: nd.po_no,
                                invoice_no: nd.invoice_no,
                                delivery_agent_id: nd.delivery_agent_id,
                                delivery_date: nd.delivery_date,
                                geo_location: nd.geo_location,
                                route_id: nd.route_id
                                // signature : nd.signature
                            });
                        }
                    });
                }

                let body = { rows: rows, approval_pending: approvalRequired ? 1 : 0, src: 'Web' };
                DeliveryService.createDelivery(body, { 'user-id': this.props.user.id, 'user-name': this.props.user.name })
                    .then((data) => {
                        console.log(data);
                        if (data.multiple_deliveries > 0 && data.success === 0) {
                            this.props.showConfirmDialog(`Cannot schedule more than 1 Delivery per day for this store`, undefined, undefined)
                        } else if (data.already_delivered > 0 && data.success === 0) {
                            this.props.showConfirmDialog(`Delivery is already completed for this store. Please refresh the page to check status.`, undefined, undefined)
                        } else {
                            this.resetNewDelivery();
                            this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, this.state.selectedDate);
                            this.fetchCalendarMarkers(this.state.selectedDate);
                            let today = moment(nd.schedule_date).startOf('day').isSame(moment().startOf('day'));
                            if (!nd.delivery_date && today) {
                                NotificationService.notifyAgentsAboutDeliveryChanges(nd.route_id, nd.schedule_date, nd.store_name);
                            }
                            this.handleCloseNew();
                        }
                        this.setState({ loading: false });
                    })
                    .catch((error) => {
                        console.log(error);
                        this.setState({ loading: false });
                    });
            });
        } else {
            this.props.showSnackBar(message, 'warning')
        }

    }

    scheduleNewDelivery(e) {
        if (e) {
            e.preventDefault();
        }
    }

    resetNewDelivery() {
        this.setState({ new_delivery: { schedule_date: moment(), products: new Map(), returns: new Map(), delivery_date: undefined } });
    }

    updateDeliveryDetails(store_id, invoice_no, transaction_id) {
        this.fetchProductRows(store_id, invoice_no, transaction_id);
    }

    resendCreditNote = (e, user) => {
        if (e) {
            e.preventDefault();
        }
        if (user.returned_count > 0) {
            this.props.showConfirmDialog(`Confirm re-send Credit note for ${user.store_name}?`, undefined, () => {
                let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, invoice_no: user.invoice_no };
                DeliveryService.resendCreditNote(body, Constants.STORE)
                    .then((data) => {
                        console.log(data);
                        this.props.closeConfirmDialog();
                        if (data.success) {
                            this.props.showSnackBar('Credit note sent successfully', 'success');
                        } else {
                            this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                        }
                    })
                    .catch(() => {
                        this.props.closeConfirmDialog();
                        console.log("Error Occurred while resending Credit Note");
                        this.props.showSnackBar('Something went wrong. Please try again later or contact the admin', 'error');
                    });
            });
        }
    }

    resendInvoice(e, user, msg) {
        if (e) {
            e.preventDefault();
        }
        if (user.invoice_no) {
            this.props.showConfirmDialog(msg ? msg : `Confirm re-send invoice for ${user.store_name}?`, undefined, () => {
                let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, invoice_no: user.invoice_no };
                DeliveryService.resendInvoice(body, Constants.STORE)
                    .then((data) => {
                        console.log(data);
                        this.props.closeConfirmDialog();
                        if (data.success) {
                            this.props.showSnackBar('Invoice sent successfully', 'success');
                        } else {
                            this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                        }
                    })
                    .catch(() => {
                        this.props.closeConfirmDialog();
                        console.log("Error Occurred while resending Invoice");
                        this.props.showSnackBar('Something went wrong. Please try again later or contact the admin', 'error');
                    });

                if (msg) {
                    if (user.returned_count > 0) {
                        let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, invoice_no: user.invoice_no };
                        DeliveryService.resendCreditNote(body, Constants.STORE)
                            .then((data) => {
                                console.log(data);
                                this.props.closeConfirmDialog();
                                if (data.success) {
                                    this.props.showSnackBar('Credit note sent successfully', 'success');
                                } else {
                                    this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                                }
                            })
                            .catch(() => {
                                this.props.closeConfirmDialog();
                                console.log("Error Occurred while resending Credit Note");
                                this.props.showSnackBar('Something went wrong. Please try again later or contact the admin', 'error');
                            });
                    }
                }
            });
        }
    }

    edit(e, user, approvalRequired = false) {
        e.preventDefault();
        let nd = this.state.new_delivery;
        nd.store_id = user.id;
        nd.transaction_id = user.transaction_id;
        nd.delivery_date = user.delivery_date;
        nd.route_id = user.route_id;
        nd.store_name = user.store_name;
        nd.schedule_date = user.schedule_date;
        nd.invoice_no = user.invoice_no && user.invoice_no.length > 0 ? user.invoice_no : undefined;
        if (approvalRequired) {
            nd.delivery_agent_id = user.delivery_agent_id;
            nd.geo_location = user.geo_location;
            // nd.signature = user.signature;
        }
        fetchStoreContracts(nd.store_id, (contractMap) => {
            console.log(contractMap)
            this.setState({
                new_delivery: nd,
                editMode: true,
                approvalRequired: approvalRequired,
                new_delivery_orginal: approvalRequired ? Object.assign({}, nd) : undefined,
                store_contract: contractMap
            }, () => this.handleShowNew());
        });
    }

    delete(e, user) {
        e.preventDefault();
        this.props.showConfirmDialog(`Delete Delivery Schedule for ${user.store_name}?`, undefined, () => {
            this.props.isLoading(true);
            let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, transaction_id: user.transaction_id };
            DeliveryService.removeDelivery(body, { 'user-id': this.props.user.id, 'user-name': this.props.user.name })
                .then((data) => {
                    console.log(data);
                    this.props.closeConfirmDialog();
                    if (data.success) {
                        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, this.state.selectedDate);
                        this.fetchCalendarMarkers(this.state.selectedDate);
                    } else {
                        this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                    }
                    this.hide();
                    this.props.isLoading(false);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    collectPayment(e, user) {
        if (e)
            e.preventDefault();
        this.setState({ collectPaymentModal: null }, () => {
            let collectPaymentModal = <CollectPayment user={user} amount={user.remaining_amount} agent_id={this.props.user.id} postUpdate={this.postUpdate} showConfirmDialog={this.props.showConfirmDialog} closeConfirmDialog={this.props.closeConfirmDialog} showSnackBar={this.props.showSnackBar} />;
            this.setState({ collectPaymentModal: collectPaymentModal });
        });
    }

    postUpdate() {
        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, this.state.selectedDate, false, true);
    }

    handleApprove = () => {
        if (this.state.modal.store && this.state.modal.deliveries.length > 0) {
            this.props.showConfirmDialog(`Confirm Approval for Store ${this.state.modal.store.store_name}?`, undefined, () => {
                this.setState({ loading: true });
                this.props.closeConfirmDialog();
                handleApproveStoreDeliveryChange(this.state.modal.store.invoice_no, this.props.user.id, { 'user-id': this.props.user.id, 'user-name': this.props.user.name }, (data) => {
                    console.log(data);
                    if (data.success) {
                        this.handleClose();
                        this.props.showSnackBar('Approved', 'success');
                        if (this.state.modal.store.generate_invoice) {
                            this.resendInvoice(undefined, this.state.modal.store, `Regenerate and re-send invoice and credit note for ${this.state.modal.store.store_name}?`);
                        }
                        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, this.state.selectedDate, false, true);
                    } else {
                        this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                    }
                    this.setState({ loading: false });
                }, (error) => {
                    console.log(error);
                    this.setState({ loading: false });
                })
                // let body = { invoice_no: this.state.modal.store.invoice_no, approver_user_id: this.props.user.id };
                // DeliveryService.approveDeliveryChange(body)
                // .then((data) => {

                // });
            });
        }
    }

    render() {
        let message = this.state.message;
        let session_user = this.props.user;
        return (
            <div className="Home" style={{ marginTop: 32 }}>
                <div>
                    <ReactDatePicker
                        className="datePicker"
                        selected={this.state.selectedDate}
                        onChange={this.handleDateChange}
                        onMonthChange={this.handleMonthChange}
                        highlightDates={this.state.highlightDates}
                        todayButton={"TODAY"}
                        tabIndex={1}
                        monthsShown={2}
                        inline />
                    <div style={{ float: "right" }}></div>
                </div>
                <div className="">
                    <p style={{ color: "red", paddingLeft: "20px" }}>{message}</p>
                    {/* <Table striped condensed hover responsive>
                            <thead>
                                <tr>
                                    <th>Store</th>
                                    <th>Manager Name</th>
                                    <th>Contact No</th>
                                    <th>Address</th>
                                    <th>Invoice No</th>
                                    <th>PO No</th>
                                    <th>Issued Qty</th>
                                    <th>Total Amount</th>
                                    <th>Delivered Count</th>
                                    <th>Returned Count</th>
                                    <th>Delivery Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody style={{textAlign: "left"}}>
                                {this.state.current_rows}
                            </tbody>
                        </Table> */}
                    {!message &&
                        <Paper className={this.props.classes.root} style={{ width: "100%", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px", marginBottom: 80 }}>
                            <Table striped condensed hover responsive>
                                <EnhancedTableHead
                                    order={'asc'}
                                    orderBy={'store_name'}
                                    onRequestSort={() => { }}
                                    rows={this.state.columns} />

                                {/* <tbody style={{textAlign: "left"}}>
                                    {this.state.current_rows}
                                </tbody> */}
                                <TableBody>
                                    {this.state.current_rows}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </Paper>
                    }
                </div>
                <DialogMUI
                    open={this.state.show}
                    onClose={this.handleClose}
                    fullWidth={true}
                    maxWidth={'lg'}
                    style={{ paperWidthSm: '17' }}
                    aria-labelledby="responsive-dialog-title"
                    scroll='paper'>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                    <DialogTitle id="alert-dialog-title">{`Delivery Details - ${this.state.modal.store.store_name} ${this.state.modal.store.invoice_no ? "[Invoice: " + this.state.modal.store.invoice_no + "]" : ""}`}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <Divider />
                            <Table striped condensed hover responsive>
                                <thead>
                                    <tr>
                                        <th>Invoice No</th>
                                        <th>Product Name</th>
                                        <th>Scheduled Qty</th>
                                        <th>Total Amount</th>
                                        <th>Delivered Count</th>
                                        <th>Returned Count</th>
                                        <th>Return Reason</th>
                                        <th>Reason</th>
                                        <th>Delivery Date</th>
                                    </tr>
                                </thead>
                                <tbody style={{ textAlign: "left" }}>
                                    {this.state.modal.deliveries}
                                </tbody>
                            </Table>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {this.state.show_approval_option &&
                            <Button onClick={this.handleApprove} color="secondary" autoFocus disabled={this.state.loading}>
                                Approve
                            </Button>
                        }
                        <Button onClick={this.handleClose} color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                </DialogMUI>
                {/* Schedule Future Deliveries for Stores */}
                <DialogMUI
                    fullWidth={true}
                    maxWidth="md"
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.state.showNewDelivery}
                    onClose={this.handleCloseNew}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                    <DialogTitle id="alert-dialog-title">
                        Delivery Details
                        {this.state.approvalRequired &&
                            <Typography variant="button" id="modal-title" color="secondary">
                                <br />[NOTE] This change Requires Approval as the delivery has already been taken place
                            </Typography>
                        }
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <FormGroup>
                                <ControlLabel>Store<sup>*</sup></ControlLabel>
                                <Typeahead disabled={this.state.editMode}
                                    id="typeahead-id-store-delivery-schedule"
                                    onChange={(selected) => {
                                        let nd = this.state.new_delivery;
                                        if (selected.length > 0) {
                                            if (this.state.scheduling_due_check && parseFloat(selected[0].allowed_credit_limit || -1) > 0 && parseFloat(selected[0].pending_amount || 0) >= parseFloat(selected[0].allowed_credit_limit || -1)) {
                                                this.props.showConfirmDialog("Billing is disabled for the store as the Credit has crossed the allowed limit", undefined, undefined);
                                                this.setState({ disableScheduling: (this.state.scheduling_due_check && parseFloat(selected[0].allowed_credit_limit || -1) > 0 && parseFloat(selected[0].pending_amount || 0) >= parseFloat(selected[0].allowed_credit_limit || -1))})
                                            } else {
                                                fetchStoreContracts(selected[0].id, (contractMap) => {
                                                    console.log(contractMap);
                                                    nd.store_id = selected[0].id;
                                                    nd.store_name = selected[0].store_name
                                                    nd.route_id = selected[0].route_name;
                                                    nd.po_no = selected[0].po_no;
                                                    this.setState({ new_delivery: nd, store_contract: contractMap, disableScheduling: false }, () => {
                                                        this.updateDeliveryDetails(nd.store_id, nd.invoice_no, nd.transaction_id);
                                                    });
                                                });
                                            }
                                        } else {
                                            this.setState({ new_delivery: { schedule_date: moment(), products: new Map(), returns: new Map(), delivery_date: undefined } });
                                            this.fetchProductRows(null, undefined);
                                        }
                                    }}
                                    options={this.state.storeList.filter((store) => store.route_id
                                        //&& !this.state.storeDeliveryMap.has(store.id)
                                    )}
                                    labelKey={option => `${option.store_name} [Address: ${option.flat}]`}
                                    filterBy={['store_name', 'flat']}
                                    placeholder="Store"
                                    clearButton
                                    defaultSelected={
                                        this.state.storeList.filter((store) => store.id === this.state.new_delivery.store_id)
                                    } />
                                <HelpBlock>Stores which are mapped to a route will only be available for scheduling.</HelpBlock>
                            </FormGroup>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    disabled={this.state.editMode}
                                    margin="dense"
                                    label="Delivery Date"
                                    value={this.state.new_delivery.schedule_date}
                                    onChange={this.handleDeliveryDateChange}
                                    format='DD/MM/YYYY'
                                    minDate={this.state.approvalRequired ? undefined : moment()}
                                    style={{ height: "100%", marginRight: "20px" }}
                                />
                            </MuiPickersUtilsProvider>
                            <TextField
                                label="PO number"
                                placeholder="PO number"
                                name={"po_no"}
                                defaultValue={this.state.new_delivery.po_no}
                                className={this.props.classes.textField}
                                margin="dense"
                                variant="outlined"
                                onChange={this.handleChangePO}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">PO</InputAdornment>
                                }} />
                            <Typography variant="subtitle1" id="modal-title">
                                Products
                            </Typography>
                            <Divider variant='middle' />
                            <Table striped>
                                <tbody>
                                    {this.state.product_rows}
                                </tbody>
                            </Table>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Typography variant="button" id="modal-title" style={{ float: 'left', width: '70%' }}>
                            Only Products for which contracts are defined are shown.
                        </Typography>
                        <Button onClick={this.handleCloseNew} color="primary">
                            Close
                        </Button>
                        <Button onClick={this.confirmScheduleNewDelivery} color="primary" autoFocus disabled={this.state.loading || this.state.disableScheduling}>
                            {
                                this.state.approvalRequired ? 'Schedule Changes' : 'Schedule'
                            }
                        </Button>
                    </DialogActions>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                </DialogMUI>
                {this.state.collectPaymentModal}
                {(session_user.roles.includes(ROLES.STORE_MANAGEMENT) || session_user.roles.includes(ROLES.ADMIN)) &&
                    (
                        !this.state.selectedDate.isBefore(moment().startOf('day')) &&
                        <Fab onClick={this.handleShowNew} color="primary" aria-label="Add" className={this.props.classes.fab} style={{ position: 'fixed', top: '85%', left: '90%' }}>
                            <AddIcon />
                        </Fab>
                    )
                }
            </div>
        );
    }
}

class DeliveryDetails extends Component {

    render() {
        const user = this.props.user;
        let status_badge = '';
        let away = parseFloat(user.away);
        let session_user = this.props.session_user;
        let isMarkedNotDeliverable = (user.delivered_count === 0 && user.delivery_date && user.delivery_agent_id ? true : false);
        if (user.invoice_no) {
            let hasPendingRecord = user.transactions.filter(t => t.status === PaymentStatus.PENDING)[0];
            if (!hasPendingRecord) {
                let collected_amount = user.transactions.reduce(function (accumulator, t) {
                    return t.status === PaymentStatus.COLLECTED ? accumulator + parseFloat(t.amount) : accumulator;
                }, 0);
                if (collected_amount !== user.total_amount) {
                    user.payment_status = PaymentStatus.PENDING;
                    user.remaining_amount = user.total_amount - collected_amount;
                } else {
                    user.payment_status = PaymentStatus.COLLECTED;
                    user.remaining_amount = 0;
                }
            } else {
                user.payment_status = PaymentStatus.PENDING;
                user.remaining_amount = parseFloat(hasPendingRecord.amount);
            }
        }

        switch (user.payment_status) {
            case PaymentStatus.PENDING:
                status_badge = <Badge style={{ fontSize: "14px", backgroundColor: "#6D757D" }}>{user.payment_status}</Badge>;
                break;
            case PaymentStatus.COLLECTED:
                status_badge = <Badge style={{ fontSize: "14px", backgroundColor: "#28A745" }}>{user.payment_status}</Badge>;
                break;
            case PaymentStatus.CANCELLED:
                status_badge = <Badge style={{ fontSize: "14px", backgroundColor: "#DC3545" }}>{user.payment_status}</Badge>;
                break;
            default:
                status_badge = ''
        }
        return (
            <tr className={!user.delivery_date && moment(user.schedule_date).utc().isBefore(moment().startOf('day')) ? "danger" : user.approval_pending === '1' ? 'approval_pending' : ''} >
                <td>{user.store_name}</td>
                <td>{user.name}</td>
                <td>{user.mobile_no}</td>
                <td>{user.flat}</td>
                <td>
                    {user.invoice_no && !user.invoice_no.startsWith("DONT-GENERATE") ? user.invoice_no : ((user.delivery_date ? "NA" : "-"))}<br />
                    {user.generate_invoice ? status_badge : ""}
                </td>
                <td>{user.grn || '-'}</td>
                <td>{user.po_no || '-'}</td>
                <td>{user.delivery_date ? (away >= 0 ?
                    <Tooltip title={`Marked at a distance of ${convertDistance(away)} from store`}>
                        <Chip label={convertDistance(away)} color={away > 50 ? "secondary" : "primary"} variant={away > 50 ? "default" : "outlined"} />
                    </Tooltip>
                    : <Chip label={away === -1 ? "Failed to Obtain location" : "Not available"} variant="outlined" color="secondary" />) : '-'}
                </td>
                <td>{user.product_qty}</td>
                <td>{formatNumber(Math.round(user.total_amount))}</td>
                <td>{(user.approval_pending === '1' && (user.delivered_count !== 0 || user.revised_delivered_count !== 0) && user.delivered_count !== user.revised_delivered_count) ? (<span><strike style={{ color: 'red' }}>{user.delivered_count}</strike><br /> {user.revised_delivered_count}</span>) : user.delivered_count}</td>
                <td>{(user.approval_pending === '1' && (user.returned_count !== 0 || user.revised_returned_count !== 0) && user.returned_count !== user.revised_returned_count) ? (<span><strike style={{ color: 'red' }}>{user.returned_count}</strike><br /> {user.revised_returned_count}</span>) : user.returned_count}</td>
                {/* <td>{user.replaced_count}</td> */}
                <td>{user.delivery_date ? <ListItemText style={isMarkedNotDeliverable ? { color: "#b71c1c" } : {}} primary={getTimeInIST(user.delivery_date).format(format_fancy)} secondary={isMarkedNotDeliverable ? user.reason : ""} /> : "-"}</td>
                <td style={{ textAlign: "right" }}>
                    <OverlayTrigger overlay={popover("Schedule details")}>
                        <Glyphicon glyph="list-alt" onClick={(e) => this.props.showDetails(e, user)} />
                    </OverlayTrigger>
                    {(session_user.roles.includes(ROLES.ACCOUNTS_ADMIN) || session_user.roles.includes(ROLES.ADMIN)) && user.approval_pending === '1' ?
                        <OverlayTrigger overlay={popover("Approve the Changes")} >
                            <Glyphicon glyph="ok" onClick={(e) => this.props.showDetails(e, user)} style={{ marginLeft: "10px" }} />
                        </OverlayTrigger>
                        :
                        ''
                    }
                    {
                        (session_user.roles.includes(ROLES.STORE_MANAGEMENT) || session_user.roles.includes(ROLES.ADMIN)) && (
                            user.delivery_date || moment(user.schedule_date).utc().isBefore(moment().startOf('day')) ? "" : <Glyphicon glyph="trash" style={{ marginLeft: "10px" }} onClick={(e) => this.props.delete(e, user)} />
                        )
                    }
                    {(session_user.roles.includes(ROLES.STORE_MANAGEMENT) || session_user.roles.includes(ROLES.ADMIN)) && (
                        user.delivery_date && moment(user.delivery_date).isAfter(moment().startOf('day').add(-1, 'day')) && !isMarkedNotDeliverable ?
                            <OverlayTrigger overlay={popover("Edit Delivery (Requires Admin Approval)")}>
                                <Glyphicon glyph="pencil" style={{ marginLeft: "10px" }} onClick={(e) => this.props.edit(e, user, true)} />
                            </OverlayTrigger>
                            :
                            (getTimeInIST(user.schedule_date).utc().isBefore(moment().startOf('day')) ? "" :
                                <OverlayTrigger overlay={popover("Edit Delivery")}>
                                    <Glyphicon glyph="pencil" style={{ marginLeft: "10px" }} onClick={(e) => this.props.edit(e, user, false)} />
                                </OverlayTrigger>)
                    )}
                    {user.approval_pending !== '1' && (user.generate_invoice || !user.invoice_no.startsWith("DONT-GENERATE")) && user.delivery_date && user.delivered_count > 0 ?
                        <OverlayTrigger overlay={popover("Re-send Invoice")}>
                            <Glyphicon glyph="envelope" onClick={(e) => this.props.resendInvoice(e, user)} style={{ marginLeft: "10px" }} />
                        </OverlayTrigger>
                        : ""
                    }
                    {user.approval_pending !== '1' &&
                        (user.generate_invoice || !user.invoice_no.startsWith("DONT-GENERATE")) && user.delivery_date && user.returned_count > 0 ?
                        <OverlayTrigger overlay={popover("Re-send Credit Note")}>
                            <Glyphicon glyph="envelope" onClick={(e) => this.props.resendCreditNote(e, user)} style={{ marginLeft: "10px" }} />
                        </OverlayTrigger>
                        : ""
                    }
                    {user.approval_pending !== '1' &&
                        (user.generate_invoice || !user.invoice_no.startsWith("DONT-GENERATE")) && user.invoice_url && user.delivery_date ?
                        <OverlayTrigger overlay={popover("View Invoice")}>
                            <Glyphicon glyph="hand-up" onClick={() => window.open(user.invoice_url, "_blank")} style={{ marginLeft: "10px" }} />
                        </OverlayTrigger>
                        : ""
                    }
                    {user.approval_pending !== '1' &&
                        (user.generate_invoice || !user.invoice_no.startsWith("DONT-GENERATE")) && user.credit_note_url && user.delivery_date && user.returned_count > 0 ?
                        <OverlayTrigger overlay={popover("View Credit Note")}>
                            <Glyphicon glyph="file" onClick={() => window.open(user.credit_note_url, "_blank")} style={{ marginLeft: "10px" }} />
                        </OverlayTrigger>
                        : ""
                    }
                    {user.approval_pending !== '1' &&
                        (user.generate_invoice || !user.invoice_no.startsWith("DONT-GENERATE")) && user.payment_status && user.payment_status === 'PENDING' && user.invoice_no ?
                        <OverlayTrigger overlay={popover(`Collect Payment \n Remaining Amt:${Math.round(user.remaining_amount)}`)}>
                            <Glyphicon glyph="tags" onClick={(e) => this.props.collectPayment(e, user)} style={{ marginLeft: "10px" }} />
                        </OverlayTrigger>
                        : ""
                    }
                </td>
            </tr>
        );
    }
}

class ProductDeliveryDetails extends Component {

    render() {
        const delivery = this.props.delivery;

        return (
            <tr>
                <td>{delivery.delivery_date ? (delivery.invoice_no ? delivery.invoice_no : '-') : ''}</td>
                <td>{delivery.product_name}</td>
                <td>{delivery.product_qty}</td>
                <td>{formatNumber(delivery.total_amount)}</td>
                <td>{delivery.approval_pending === '1' && (delivery.delivered_count !== 0 || toInt(delivery.revised_delivered_count) !== 0) && delivery.delivered_count !== delivery.revised_delivered_count ? (<span><strike style={{ color: 'red' }}>{delivery.delivered_count}</strike><br /> {delivery.revised_delivered_count}</span>) : delivery.delivered_count}</td>
                <td>{delivery.approval_pending === '1' && (delivery.returned_count !== 0 || toInt(delivery.revised_returned_count) !== 0) && delivery.returned_count !== delivery.revised_returned_count ? (<span><strike style={{ color: 'red' }}>{delivery.returned_count}</strike><br /> {delivery.revised_returned_count}</span>) : delivery.returned_count}</td>
                {/* <td>{delivery.replaced_count}</td> */}
                <td>{delivery.return_reason ? delivery.return_reason : "-"}</td>
                <td>{delivery.reason ? delivery.reason : "-"}</td>
                <td>{delivery.delivery_date ? getTimeInIST(delivery.delivery_date).format(format_fancy) : "-"}</td>
            </tr>
        );
    }
}

export default withStyles(styles)(StoreDeliverySchedule);